import type { IDataFetcher, IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import { getAPIPrefixForRT } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsInfraUtils";
import { getKeywordsReportSortColumn } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/getKeywordsReportSortColumn";
import {
    CHANGE_DAY_COLUMN_PREFIX,
    DEFAULT_POSITION_SORTING,
    LAST_DAY_COLUMN_PREFIX,
} from "app/common/campaigns/KeywordsCampaginKeywordsTableConsts";
import { EKeywordsReportKeywordsTableMetrics } from "app/pages/digital-marketing/keywords-campaigns/reports/keywords-report/keywords-table/KeywordsReportTypes";
import fetchService from "app/common/services/salesFetchService";
const OLD_VERSION_SORTING_FORMAT = ":";
class RankTrackerKeywordsReportTableDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const {
            country,
            serpFilterTypes,
            orderBy,
            from,
            to,
            granularity,
            rangeFilter,
            intentsFilter,
            tags,
            excludeTags,
            withUntagged,
            untaggedFilter,
            excludeKeywords,
            includeKeywords,
            invertedSerpFilter,
            mainSiteSerpFilter,
            mainSitePositionTrend,
            asc,
            useCaseFilter,
            sites,
        } = widget.apiParams;

        return {
            async fetch() {
                let sortOrder = orderBy;

                //backward compatibility after changing the sorting format
                if (orderBy && orderBy.includes(OLD_VERSION_SORTING_FORMAT)) {
                    sortOrder = orderBy.split(OLD_VERSION_SORTING_FORMAT)[0];
                }
                if (orderBy && orderBy.includes(LAST_DAY_COLUMN_PREFIX)) {
                    sortOrder = orderBy.replace(
                        LAST_DAY_COLUMN_PREFIX,
                        `${LAST_DAY_COLUMN_PREFIX}${EKeywordsReportKeywordsTableMetrics.POSITION}`,
                    );
                }
                if (orderBy && orderBy.includes(CHANGE_DAY_COLUMN_PREFIX)) {
                    sortOrder = orderBy.replace(
                        CHANGE_DAY_COLUMN_PREFIX,
                        `${CHANGE_DAY_COLUMN_PREFIX}${EKeywordsReportKeywordsTableMetrics.POSITION}`,
                    );
                }
                const sortProps = getKeywordsReportSortColumn(sortOrder ?? DEFAULT_POSITION_SORTING, asc === "true");

                const params = {
                    scrapingConfigurationGuids: country,
                    serpFilter: serpFilterTypes,
                    isDaily: true,
                    campaignguid: widget._widgetConfig.properties.currentCampaignConfiguration?.id,
                    granularity: granularity?.toLowerCase(),
                    untaggedFilter: untaggedFilter ?? (withUntagged === "true" ? "include" : undefined),
                    tags,
                    excludeTags,
                    sites,
                    from,
                    to,
                    rangeFilter,
                    intentsFilter,
                    excludeKeywords,
                    includeKeywords,
                    invertedSerpFilter,
                    mainSiteSerpFilter,
                    mainSitePositionTrend,
                    useCaseFilter,
                    ...sortProps,
                };
                return fetchService.get(`${getAPIPrefixForRT(false)}/reports/keywordsReport/Table`, params);
            },
            destroy: () => undefined,
        };
    }
}

export default new RankTrackerKeywordsReportTableDataFetcherFactory();
